<template>
  <NuxtLayout name="magazine">
    <div class="page-container infopage" :class="{ 'magazine__article': isMagazine }">
      <MoleculesGlobalBreadcrumb :segments="breadcrumbSegments" />
      <AtomsTextHeader :type="1" :class="{ 'infopage__header': entity.type !== appConfig.infoPageCustomLayoutType }">{{ entity.page.header }}</AtomsTextHeader>
      <div v-if="isMagazine" class="magazine__meta">
        {{ $t('Kategorie') }}: <strong>{{ extractCategoryName(entity.magazineCategory.name) }}</strong><span class="mx-1">|</span>{{ date }}<span class="mx-1">|</span>{{ $t('Doba čtení') }}: {{ useUtils().bendWord('minuta', entity.timeToRead) }}
      </div>
      <div v-html="entity.content" :class="{ 'infopage__content': entity.type !== appConfig.infoPageCustomLayoutType }"></div>

      <!-- related products -->
      <div v-if="entity.wareList?.wares.count">
        <h2 class="mt-12 mb-6 text-2xl font-secondary">{{ $t('Související produkty') }}</h2>
        <OrganismsListsWareList :items="entity.wareList.wares.items" :with-sorting="false" type="slider" list-name="Související produkty u článku" />
      </div>

      <!-- another magazine articles -->
      <template v-if="isMagazine">
        <TemplatesNewestMagazineArticles :header="i18n.t('Další články v magazínu')" />
        <div class="text-right uppercase font-bold">
          <AtomsGlobalLink :to="appConfig.definedPageUrls.magazine">
            <AtomsImagesIcon icon="sipkaDoleva" class="mr-4" /> {{ $t('zpět do magazínu') }}
          </AtomsGlobalLink>
        </div>
      </template>
    </div>
  </NuxtLayout>
</template>

<script setup>

const entity = useEntity();
const appConfig = useAppConfig();
const i18n = useI18n();
const locale = useLocale().getLocale();
const analytics = useAnalytics();

const isMagazine = entity.kind === 2 && !!entity.magazineCategory;

const breadcrumbSegments = [];

if (isMagazine) {
  breadcrumbSegments.push({ url: appConfig.definedPageUrls.magazine, name: i18n.t('Svatební magazín') });

  const articleAnalyticsData = {
    article_id: entity.id,
    article_type: 'Magazín',
    article_title: entity.page.header,
    article_author: entity.author,
    article_category: entity.magazineCategory?.name,
    article_reading_time: entity.timeToRead?.toString(),
    article_published: entity.page.publishedAt ?? entity.page.lastModifiedAt ?? entity.created,
  };

  analytics.pushEvent('article_view', articleAnalyticsData);

}

breadcrumbSegments.push({ url: usePage().value.page.url, name: usePage().value.page.title });

const date = new Date(entity.page.lastModifiedAt ? (entity.created > entity.page.lastModifiedAt ? entity.created : entity.page.lastModifiedAt) : entity.created).toLocaleDateString(locale.locale);

const extractCategoryName = (nameWithPrefix) => nameWithPrefix.slice(nameWithPrefix.indexOf('-') + 1);


</script>
<style lang="postcss">
.infopage {
  @apply py-6;

  &__contacts {
    .grid {
      grid-template-areas: "a" "b" "c" "d" "e";
      @apply gap-4;

      @media screen(lg) {
        grid-template-areas: "c a b" "c d e";
        grid-template-columns: repeat(3, 1fr);
      }

      &>div {
        @apply p-4 pt-8 xl:p-6 xl:pt-10 shadow-around text-lg;
      }
    }
  }

  &__header {
    @apply max-w-[700px] mx-auto lg:mt-4;
  }

  &__content {

    @apply max-w-[700px] mx-auto;

    h2 {
      @apply my-8 text-xl font-bold;
    }

    h3 {
      @apply my-4 text-lg font-bold;
    }

    p {
      @apply my-4 text-justify;
    }

    a {
      @apply text-primary underline hover:no-underline;
    }

    ul {
      @apply ml-5;
      list-style-type: disc;
    }

    img {
      @apply mx-auto;
    }

    table {
      td {
        @apply px-4 py-2;
      }

      tr {
        @apply even:bg-silver;
      }
    }
  }
}

.magazine {

  &__meta {
    @apply max-w-[700px] mx-auto my-6 text-gray;
  }

  &__article {

    .infopage__content {
      @apply leading-7;

      figure {
        @apply my-8 text-center;

        figcaption {
          @apply mt-3 text-sm text-gray;
        }
      }
    }
  }
}
</style>